import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SettingsPage.css'; // Импортируем стили
import SettingsTab from './SettingsTab';

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState('okpSettings'); // Вкладка по умолчанию - OKP
  const [parameters, setParameters] = useState([]); // Список параметров
  const [newParam, setNewParam] = useState({ name: '', description: '', type: '', unit: '' }); // Новый параметр
  const [editParam, setEditParam] = useState(null); // Параметр для редактирования
  const [isLoading, setIsLoading] = useState(false); // Для загрузки
  const [okpList, setOkpList] = useState([]); // Список ОКП
  const [newOkp, setNewOkp] = useState({ name: '', description: '' }); // Новый ОКП
  const [editOkp, setEditOkp] = useState(null); // ОКП для редактирования

  


  // Получение всех параметров при загрузке компонента
  useEffect(() => {
    fetchParameters();
    fetchOkpList();
  }, []);

  // Функция для получения всех параметров
  const fetchParameters = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/DictionaryParameters`);
      setParameters(response.data);
    } catch (error) {
      console.error('Ошибка получения параметров:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Функция для добавления нового параметра
  const addParameter = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/DictionaryParameters`, newParam);
      setParameters([...parameters, response.data]); // Обновляем список параметров
      setNewParam({ name: '', description: '', type: '', unit: '' }); // Очищаем форму
    } catch (error) {
      console.error('Ошибка добавления параметра:', error);
    }
  };

  // Функция для изменения параметра
  const updateParameter = async (param) => {
    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/DictionaryParameters/${param.id}`, param);
      fetchParameters(); // Обновляем список параметров после изменения
      setEditParam(null); // Завершаем режим редактирования
    } catch (error) {
      console.error('Ошибка изменения параметра:', error);
    }
  };

  // Функция для удаления параметра
  const deleteParameter = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/DictionaryParameters/${id}`);
      setParameters(parameters.filter((param) => param.id !== id)); // Удаляем параметр из списка
    } catch (error) {
      console.error('Ошибка удаления параметра:', error);
    }
  };
   // Функция для получения всех ОКП
  const fetchOkpList = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/OKPDictionary`);
      setOkpList(response.data);
    } catch (error) {
      console.error('Ошибка получения списка ОКП:', error);
    } finally {
      setIsLoading(false);
    }
  };
  // Функция для добавления нового ОКП
  const addOkp = async () => {
    if (!newOkp.name || !newOkp.description) {
      alert('Название и описание обязательны для заполнения');
      return;
    }
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/OKPDictionary`, newOkp);
      setOkpList([...okpList, response.data]); // Обновляем список ОКП
      setNewOkp({ name: '', description: '' }); // Очищаем форму
    } catch (error) {
      console.error('Ошибка добавления ОКП:', error);
    }
  };
  // Функция для изменения ОКП
  const updateOkp = async (okp) => {
    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/OKPDictionary/${okp.id}`, okp);
      fetchOkpList(); // Обновляем список ОКП после изменения
      setEditOkp(null); // Завершаем режим редактирования
    } catch (error) {
      console.error('Ошибка изменения ОКП:', error);
    }
  };
   // Функция для удаления ОКП
   const deleteOkp = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/OKPDictionary/${id}`);
      setOkpList(okpList.filter((okp) => okp.id !== id)); // Удаляем ОКП из списка
    } catch (error) {
      console.error('Ошибка удаления ОКП:', error);
    }
  };

  return (
    <div className="settings-page">
      <div className="tabs">
        <button
          className={`tab-buttons ${activeTab === 'okpSettings' ? 'active' : ''}`}
          onClick={() => setActiveTab('okpSettings')}
        >
          Настройка OKP
        </button>
        <button
          className={`tab-buttons ${activeTab === 'dictionarySettings' ? 'active' : ''}`}
          onClick={() => setActiveTab('dictionarySettings')}
        >
          Настройка словаря параметров
        </button>
        <button
    className={`tab-buttons ${activeTab === 'settings-tab' ? 'active' : ''}`}
    onClick={() => setActiveTab('settings-tab')}
  >
    Настройка шаблонов Workflow
  </button>
      </div>
      

      <div className="tab-content">
        {activeTab === 'okpSettings' && (
          <div>
            <h2>Настройка OKP</h2>
                        {/* Форма для создания нового ОКП */}
                        <div className="okp-form">
              <h3>Создать новый ОКП</h3>
              <input
                type="text"
                placeholder="Название ОКП"
                value={newOkp.name}
                onChange={(e) => setNewOkp({ ...newOkp, name: e.target.value })}
              />
              <input
                type="text"
                placeholder="Описание"
                value={newOkp.description}
                onChange={(e) => setNewOkp({ ...newOkp, description: e.target.value })}
              />
              <button className="button" onClick={addOkp}>Добавить ОКП</button>
            </div>

            {/* Таблица с ОКП */}
            <div className="okp-table">
              {isLoading ? (
                <p>Загрузка...</p>
              ) : (
                <table>
                  <thead>
                    <tr>
                      <th>Название ОКП</th>
                      <th>Описание</th>
                      <th>Действия</th>
                    </tr>
                  </thead>
                  <tbody>
                    {okpList.map((okp) => (
                      <tr key={okp.id}>
                        <td>
                          {editOkp?.id === okp.id ? (
                            <input
                              type="text"
                              value={editOkp.name}
                              onChange={(e) => setEditOkp({ ...editOkp, name: e.target.value })}
                            />
                          ) : (
                            okp.name
                          )}
                        </td>
                        <td>
                          {editOkp?.id === okp.id ? (
                            <input
                              type="text"
                              value={editOkp.description}
                              onChange={(e) =>
                                setEditOkp({ ...editOkp, description: e.target.value })
                              }
                            />
                          ) : (
                            okp.description
                          )}
                        </td>
                        <td>
                          {editOkp?.id === okp.id ? (
                            <>
                              <button onClick={() => updateOkp(editOkp)}>Сохранить</button>
                              <button onClick={() => setEditOkp(null)}>Отмена</button>
                            </>
                          ) : (
                            <>
                              <button onClick={() => setEditOkp(okp)}>Изменить</button>
                              <button onClick={() => deleteOkp(okp.id)}>Удалить</button>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}
        {activeTab === 'dictionarySettings' && (
          <div>
            <h2>Настройка словаря параметров</h2>

            {/* Форма для создания нового параметра */}
            <div className="parameter-form">
              <h3>Создать новый параметр</h3>
              <input
                type="text"
                placeholder="Название параметра"
                value={newParam.name}
                onChange={(e) => setNewParam({ ...newParam, name: e.target.value })}
              />
              <input
                type="text"
                placeholder="Описание"
                value={newParam.description}
                onChange={(e) => setNewParam({ ...newParam, description: e.target.value })}
              />
              <input
                type="text"
                placeholder="Тип"
                value={newParam.type}
                onChange={(e) => setNewParam({ ...newParam, type: e.target.value })}
              />
              <input
                type="text"
                placeholder="Единица измерения"
                value={newParam.unit}
                onChange={(e) => setNewParam({ ...newParam, unit: e.target.value })}
              />
              <button className="button" onClick={addParameter}>Добавить параметр</button>
            </div>

            {/* Таблица с параметрами */}
            <div className="parameter-table">
              {isLoading ? (
                <p>Загрузка...</p>
              ) : (
                <table>
                  <thead>
                    <tr>
                      <th>Название</th>
                      <th>Описание</th>
                      <th>Тип</th>
                      <th>Единица измерения</th>
                      <th>Действия</th>
                    </tr>
                  </thead>
                  <tbody>
                    {parameters.map((param) => (
                      <tr key={param.id}>
                        <td>
                          {editParam?.id === param.id ? (
                            <input
                              type="text"
                              value={editParam.name}
                              onChange={(e) => setEditParam({ ...editParam, name: e.target.value })}
                            />
                          ) : (
                            param.name
                          )}
                        </td>
                        <td>
                          {editParam?.id === param.id ? (
                            <input
                              type="text"
                              value={editParam.description}
                              onChange={(e) =>
                                setEditParam({ ...editParam, description: e.target.value })
                              }
                            />
                          ) : (
                            param.description
                          )}
                        </td>
                        <td>{param.type}</td>
                        <td>
                          {editParam?.id === param.id ? (
                            <input
                              type="text"
                              value={editParam.unit}
                              onChange={(e) => setEditParam({ ...editParam, unit: e.target.value })}
                            />
                          ) : (
                            param.unit
                          )}
                        </td>
                        <td>
                          {editParam?.id === param.id ? (
                            <>
                              <button onClick={() => updateParameter(editParam)}>Сохранить</button>
                              <button onClick={() => setEditParam(null)}>Отмена</button>
                            </>
                          ) : (
                            <>
                              <button onClick={() => setEditParam(param)}>Изменить</button>
                              <button onClick={() => deleteParameter(param.id)}>Удалить</button>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        )}
        {activeTab === 'settings-tab' && <SettingsTab />} {/* Добавлено для отображения SettingsTab */}
      </div>
    </div>
  );
};

export default SettingsPage;
